import { IonAlert, IonApp, IonItem, IonLabel, IonPage, IonRouterOutlet, IonRow, IonSplitPane } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import React, { useContext, useEffect, useState } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import Home from "./pages/Home";

import { AuthState, onAuthUIStateChange } from "@aws-amplify/ui-components";
import { AmplifyAuthenticator, AmplifySignIn } from "@aws-amplify/ui-react";
import Amplify, { Auth } from "aws-amplify";
import { I18n } from "@aws-amplify/core";
import * as ApiService from "../src/services/ApiService";

import { ENV } from "../src/environments/env";
import {
  ApplicationContext,
  ProviderContextProvider,
} from "./ApplicationState";
import { Menu } from "./components/Menu/Menu";
import ContactUs from "./pages/ContactUs";
import Patients from "./pages/patients/patients";
import Provider from "./pages/providers/provider";
import Providers from "./pages/providers/providers";
import GroupReadings from "./pages/Readings/GroupReadings";
import Readings from "./pages/Readings/Readings";
import BillingReport from "./pages/Reports/BillingReport";
import Threshold from "./pages/Threshold/Threshold";
import Register from "./pages/UserProfile/Register";
import UpdateProfile from "./pages/UserProfile/UpdateProfile";
import UserProfile from "./pages/UserProfile/UserProfile";
import Users from "./pages/Users/Users";
import { getUserAttributes } from "./services/Helpers";
import Notifications from "./components/Notifications/Notifications";
import ScheduleDetails from "./components/Notifications/ScheduleDetails";
import HangfireDashboard from "./components/Notifications/HangfireDashboard";
import Filemanager from "./pages/FileManager/Filemanager";
import { Groups } from "./pages/GroupsAndUsers/Groups";
import { Survey } from "./pages/Survey/Survey";
import { CreateCustomSurvey } from "./components/SurveyForms/CreateCustomSurvey";
import SurveyDisplayComponent from "./pages/Survey/SurveyDisplayComponent";
import SurveyResults from "./components/SurveyResults/SurveyResults";
import { ResultDetails } from "./components/SurveyForms/ResultDetails";
import { ReviewSurvey } from "./pages/Survey/ReviewSurvey";
import { UserSurveyResponses } from "./pages/UserProfile/UserSurveyResponses";
import { UserScheduleResponse } from "./pages/UserProfile/UserScheduleResponse";
import { Button } from "@mui/material";
import CallBack from './pages/Auth/AuthCallback';
import AuthCallback from "./pages/Auth/AuthCallback";
import { pickersCalendarHeaderClasses } from "@mui/x-date-pickers";
import EMRReadings from "./pages/Readings/EMRReadings";
import { TenoviUsers } from "./pages/Tenovi/TenoviUsers";

const dict = {

  en: {
    'Sign In': 'Sign In to your account',
    'Username *': 'Username *',
    'Password': 'Password',
    'Forgot your password?': 'Forgot your password?',
    'Reset password': 'Reset password',
    'Back to Sign In': 'Back to Sign In',
    'Enter your username': 'Enter your username',
    'Send Code': 'Send Code'
  },

  es: {
    'Sign In': 'Iniciar sesión to your account',
    'Username *': 'Usuario *',
    'Password *': 'Contraseña *',
    'Forgot your password?': 'Forgot your password?',
    'Reset password': 'Restablecer Contraseña',
    'Back to Sign In': 'Back to Sign In',
    'Enter your username': 'Enter your username',
    'Send Code': 'ENVIAR CÓDIGO'
  },
};

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: `${ENV.AWS_REGION}`,
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: `${ENV.AWS_USER_POOL_ID}`,
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: `${ENV.AWS_USER_POOL_WEBCLIENT_ID}`,
    oauth: {
      domain: 'medlinehealthtest.auth.us-east-2.amazoncognito.com',
      scope: ['openid', 'email', 'profile'],
      redirectSignIn: 'https://health-tst.medline.com/auth/authcallback',
      redirectSignOut: 'https://health-tst.medline.com/logout',
      responseType: 'code'
    }
  },
});

I18n.putVocabularies(dict);
const savedLang = localStorage.getItem("lang") || "en";
I18n.setLanguage(savedLang);

//Auth.configure();
const App: React.FC = () => {
  const { userState, setUserState } = useContext(ApplicationContext);
  //Auth.signOut();
  const [authState, setAuthState] = React.useState<AuthState>();

  const [user, setUser] = React.useState<any | undefined>(undefined);
  const [userAttributes, setUserAttributes] = React.useState<any | undefined>(
    undefined
  );
  const [isMenuCollapsed, setIsMenuCollapsed] = useState(false);

  const [language, setLanguage] = useState('en');


  const loginClinrepo = () => {
    Auth.federatedSignIn({ customProvider: 'Clinrepo' });
  };


  useEffect(() => {
    const savedLang = localStorage.getItem("lang") || "en";
    setLanguage(savedLang)

    if (user) {
      setUserState({ authenticatedUser: user });
    }
    return onAuthUIStateChange((nextAuthState, authData) => {

      if (nextAuthState === AuthState.ResetPassword) {
        setAuthState(nextAuthState);
        return null;
      }

      setAuthState(nextAuthState);

      let data: any = authData;

      if (data !== undefined) {
        setUserAttributes(
          getUserAttributes(data.signInUserSession.idToken.jwtToken)
        );
        setUser(authData);
      }

      // // ✅ Manually Sign Out After Password Change
      if (authState === AuthState.ResetPassword && nextAuthState === AuthState.SignedIn) {
        Auth.signOut().then(() => {
          window.location.href = "/"; // Redirect to login
        });
      }

    });
  }, [authState, user]);

  const handleLanguageChange = async (lang: string) => {
    try {
      setLanguage(lang);
      localStorage.setItem("lang", lang);
      I18n.putVocabularies(dict);
      I18n.setLanguage(lang);
    } catch (error) {
      console.error("Error changing language:", error);
    }
  };

  if (authState === AuthState.SignedIn && user) {
    if (
      userAttributes?.roles?.includes("Administrator") ||
      userAttributes?.roles?.includes("Provider") ||
      userAttributes?.roles?.includes("Support")
    ) {
      return (
        <IonApp>
          <ProviderContextProvider>
            <IonSplitPane contentId="main-content">
              <Menu onCollapse={(collapsed) => setIsMenuCollapsed(collapsed)} />
              <IonPage id="main-content" className={isMenuCollapsed ? "content-collapsed" : ""}>
                <IonReactRouter>
                  <IonRouterOutlet>
                    <Route exact path="/">
                      <Home />
                    </Route>
                    <Route path="/home" exact>
                      <Home />
                    </Route>
                    <Route exact path="/users">
                      <Users />
                    </Route>
                    <Route exact path="/groups">
                      <Groups />
                    </Route>
                    <Route exact path="/threshold">
                      <Threshold />
                    </Route>
                    <Route exact path="/fileManager">
                      <Filemanager />
                    </Route>
                    <Route exact path="/readings">
                      <Readings />
                    </Route>
                    <Route exact path="/group-readings">
                      <GroupReadings />
                    </Route>
                    <Route exact path="/emr-readings">
                      <EMRReadings />
                    </Route>
                    <Route exact path="/schedule">
                      <Notifications />
                    </Route>
                    <Route exact path="/addSurvey">
                      <Survey />
                    </Route>
                    <Route exact path="/reviewSurvey">
                      <ReviewSurvey />
                    </Route>
                    <Route exact path="/createSurvey">
                      <CreateCustomSurvey />
                    </Route>
                    <Route exact path="/resultDetails">
                      <ResultDetails />
                    </Route>
                    <Route exact path="/scheduleDetails">
                      <ScheduleDetails />
                    </Route>
                    <Route exact path="/hangfire">
                      <HangfireDashboard />
                    </Route>
                    <Route exact path="/patients">
                      <Patients />
                    </Route>
                    <Route exact path="/userprofile">
                      <UserProfile />
                    </Route>
                    <Route exact path="/userSurveyResponses">
                      <UserSurveyResponses />
                    </Route>
                    <Route exact path="/userScheduleResponses">
                      <UserScheduleResponse />
                    </Route>
                    <Route exact path="/register">
                      <Register />
                    </Route>
                    <Route exact path="/updateprofile">
                      <UpdateProfile />
                    </Route>
                    <Route exact path="/contact-us">
                      <ContactUs />
                    </Route>
                    <Route exact path="/providers">
                      <Providers />
                    </Route>
                    <Route exact path="/provider">
                      <Provider />
                    </Route>
                    <Route exact path="/billing-report">
                      <BillingReport />
                    </Route>
                  </IonRouterOutlet>
                </IonReactRouter>
              </IonPage>
            </IonSplitPane>
          </ProviderContextProvider>
        </IonApp>
      );
    } else if (userAttributes?.roles?.includes("Legal")) {
      return (
        <IonApp>
          <ProviderContextProvider>
            <IonSplitPane contentId="main-content">
              <Menu onCollapse={(collapsed) => setIsMenuCollapsed(collapsed)} />
              <IonPage id="main-content" className={isMenuCollapsed ? "content-collapsed" : ""}>
                <IonReactRouter>
                  <IonRouterOutlet>

                    <Route exact path="/addSurvey">
                      <Survey />
                    </Route>
                    <Route exact path="/reviewSurvey">
                      <ReviewSurvey />
                    </Route>
                    <Route exact path="/createSurvey">
                      <CreateCustomSurvey />
                    </Route>
                    <Route exact path="/resultDetails">
                      <ResultDetails />
                    </Route>

                  </IonRouterOutlet>
                </IonReactRouter>
              </IonPage>
            </IonSplitPane>
          </ProviderContextProvider>
        </IonApp>
      )
    }
    else {
      return (
        <IonAlert
          isOpen={true}
          header={"Login Failed"}
          message={
            "Sorry! you do not have permission to login to the application."
          }
          buttons={[
            {
              text: "Okay",
              handler: () => {
                Auth.signOut();
                window.location.href = "/"; // Redirect to login page
              },
            },
          ]}
        />
      );
    }

  } else {
    if (window.location.pathname.startsWith('/survey')) {
      return (
        <IonReactRouter>
          <Route path="/survey/:id">
            <SurveyDisplayComponent />
          </Route>
        </IonReactRouter>

      )
    } else if (window.location.pathname.startsWith('/auth/authcallback')) {
      return (
        <IonReactRouter>
          <Route path="/auth/authcallback">
            <AuthCallback />
          </Route>
        </IonReactRouter>

      )
    } else if (window.location.pathname.startsWith('/register/tenovi')) {
      return (
        <IonReactRouter>
          <Route path="/register/tenovi">
            <TenoviUsers />
          </Route>
        </IonReactRouter>
      )

    } else {
      return <>
        <AmplifyAuthenticator key={language}>
          <AmplifySignIn slot="sign-in" hideSignUp>
            <div slot="federated-buttons">
              {/* <Button onClick={loginClinrepo}>
              Sign in with Epic login
            </Button> */}
            </div>
          </AmplifySignIn>
        </AmplifyAuthenticator>

        <div
          style={{
            position: "fixed",
            bottom: 120,
            right: window.innerWidth / 2.3
          }}>
          <Button
            onClick={() => handleLanguageChange("en")}
            style={{
              fontWeight: language === "en" ? "bold" : "normal",
              textDecoration: language === "en" ? "underline" : "none",
              color: language === "en" ? "#007bff" : "inherit",
            }}
            variant="text"
          >
            🇺🇸 English
          </Button>
          <IonLabel style={{ margin: "0 8px" }}>|</IonLabel>
          <Button
            onClick={() => handleLanguageChange("es")}
            style={{
              fontWeight: language === "es" ? "bold" : "normal",
              textDecoration: language === "es" ? "underline" : "none",
              color: language === "es" ? "#007bff" : "inherit",
              marginRight: 20,
            }}
            variant="text"
          >
            🇪🇸 Español
          </Button>
        </div>

      </>

    }
  }
};

export default App;
